/** @format */

import {Box} from '@mui/material';

import {WarningAmber, Event} from '@mui/icons-material';

import {format} from 'date-fns';
import {ru} from 'date-fns/locale';

import {toStr} from 'helpers/stringHelpers';

import DoubleArrow from '../../icons/double-arrow.svg?react';
import {
  BetaTestBlock,
  BetaTestText,
  Cell,
  GridContainer,
  MainInfoContainer,
  MainParamsContainer,
} from './styles';
import BriefInfo from '../BriefInfo';
import {MODEL_ATTRIBUTION_MAP} from '../../constants';

export interface MainInfoProps {
  startDate: string;
  endDate: string;
  attributionModel?: string;
  buildDate: string;
  summaryInfo: string;
}

const MainInfo = ({
  startDate,
  endDate,
  attributionModel,
  buildDate,
  summaryInfo,
}: MainInfoProps) => {
  const formatDate = (dateString: string): string | null => {
    if (!startDate || !endDate || !buildDate) {
      return null;
    }

    const date = new Date(dateString);
    return format(date, 'd MMMM yyyy', {locale: ru});
  };

  return (
    <MainInfoContainer>
      <MainParamsContainer>
        <BetaTestBlock>
          <WarningAmber />
          <BetaTestText>
            <Box>ИИ-исследование находится в стадии бета-тестирования</Box>
            <Box>
              Рекомендации и прогнозы носят вероятностный характер и могут содержать неточности,
              связанные с полнотой данных
            </Box>
          </BetaTestText>
        </BetaTestBlock>
        <GridContainer>
          <Cell>
            <DoubleArrow /> Период анализа
          </Cell>
          <Cell>
            {formatDate(startDate)} - {formatDate(endDate)}
          </Cell>

          <Cell>
            <Event sx={{width: 16, height: 16}} /> Дата подготовки отчета
          </Cell>
          <Cell>{formatDate(buildDate)}</Cell>

          <Cell>Модель атрибуции</Cell>
          <Cell>{attributionModel ? MODEL_ATTRIBUTION_MAP[attributionModel] : '—'}</Cell>
        </GridContainer>
      </MainParamsContainer>
      <BriefInfo summaryInfo={toStr(summaryInfo)} />
    </MainInfoContainer>
  );
};

export default MainInfo;
